import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Renderer2, Input } from '@angular/core';
import { I18nModule, FeaturesConfigModule, ImageGroup } from '@spartacus/core';
import { MediaModule, BreakpointService, CurrentProductService, IconModule } from '@spartacus/storefront';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { GenProductImageZoomThumbnailsComponent } from './product-image-zoom-thumbnails/product-image-zoom-thumbnails.component'
import { ProductImageZoomViewComponent } from "@spartacus/product/image-zoom/components";

@Component({
  selector: 'gen-product-image-zoom-view',
  templateUrl: './product-image-zoom-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [I18nModule, FeaturesConfigModule, IconModule, CommonModule, MediaModule, GenProductImageZoomThumbnailsComponent],
})
export class GenProductImageZoomViewComponent extends ProductImageZoomViewComponent {
 
  @Input() override galleryIndex: number;
  
  constructor(
     currentProductService: CurrentProductService,
     renderer: Renderer2,
     cdRef: ChangeDetectorRef,
     breakpointService: BreakpointService
  ) {
      super(currentProductService, renderer, cdRef, breakpointService)
  }

  override openImage(item: ImageGroup | any): void {
    this.isZoomed = false;
    this.startCoords = null;
    return super.openImage(item);
  }

  override getNextProduct(thumbs: Observable<ImageGroup>[] | any): Observable<ImageGroup> {
    return super.getNextProduct(thumbs);
  }

  override getPreviousProduct(thumbs: Observable<ImageGroup>[] | any): Observable<ImageGroup> {
     return super.getPreviousProduct(thumbs);
  }

  override pointerMove(event: MouseEvent): void {
    const boundingRect = this.zoomedImage.nativeElement.getBoundingClientRect() as DOMRect;
    const imageElement = this.zoomedImage.nativeElement.querySelector('img');

    const { positionX, positionY } = this.calculatePointerMovePosition(
      this.zoomedImage,
      event.clientX,
      event.clientY
    );

    this.moveImage(positionX, positionY, boundingRect, imageElement);
  }

  override changeImage(event: { image: ImageGroup; index: number }): void {
    this.isZoomed = false;
    this.startCoords = null;
    super.changeImage(event);
  }
 
  override calculatePointerMovePosition(element: ElementRef, clientX: number, clientY: number ): { positionX: number; positionY: number } {
    const rect = element.nativeElement.getBoundingClientRect();

    // Pointer position as percentage
    const xPercent = (clientX - rect.left) / rect.width;
    const yPercent = (clientY - rect.top) / rect.height;

    // Clamp between 0–1
    const x = Math.min(Math.max(xPercent, 0), 1);
    const y = Math.min(Math.max(yPercent, 0), 1);

    // Move relative to center
    const positionX = (0.5 - x) * rect.width;
    const positionY = (0.5 - y) * rect.height;

    return { positionX, positionY };
  }
}